import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Process } from '../../models/process';
import { ProcessesQueryString } from '../../models/processesQueryString';
import { ProcessesResponse } from '../../models/processesResponse';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { TableSkeletonComponent } from './table-skeleton/table-skeleton.component';
import { StatusComponent } from './status/status.component';

@Component({
  selector: 'hub-table',
  standalone: true,
  imports: [
    ButtonModule,
    DatePipe,
    PaginatorModule,
    ReactiveFormsModule,
    SkeletonModule,
    TableModule,
    TooltipModule,
    TableSkeletonComponent,
    StatusComponent,
  ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent {
  @Output() paginatorEmitter = new EventEmitter<ProcessesQueryString>();
  @Input({ required: true }) set processesResponse(processesResponse: ProcessesResponse) {
    this.processes = processesResponse?.results;
    this.totalCount = processesResponse?.totalCount;
    this.first = processesResponse?.currentIndex * processesResponse?.pageSize;
  }
  @Input() filters: any;

  private router = inject(Router);
  public first: number = 0;
  public processes: Process[] = [];
  public rows: number = 10;
  public totalCount: number = 0;
  public page: number = 0;

  public search(event?: PaginatorState): void {
    let rows = 10;

    if (event) {
      this.page = event.page ?? 0;
      rows = event.rows ?? 10;
    }

    this.paginatorEmitter.emit({
      index: this.page,
      size: rows,
    });
  }

  public detail(id: number): void {
    sessionStorage.setItem(
      'hubapi-web-process',
      JSON.stringify({
        ...this.filters,
        index: this.page,
        size: this.rows,
      })
    );
    this.router.navigate([`process-details/${id}`]);
  }
}
